import React from 'react';
import '../App.css';
import optumlogo from '../assets/optum_logo.png';
import tamulogo from '../assets/tamu_logo.png';
import endeavrlogo from '../assets/endeavr_logo.jpeg';
const Experience = () => {
  return (

    <>
      <div className="education" id="experience-1">
        <div className="education-logo">
          <a href="https://www.optum.com/" target="_blank" rel="noreferrer"><img src={optumlogo} alt="optum Logo"></img></a>
          
        </div>
        <div className="education-text">
        <h3 className="leftalign"> Optum Global Solutions, United Health Group</h3>
          <h4 className="leftalign">Senior Data Engineer</h4>
          <h5 className="leftalign">Mar 2022 - Jan 2023</h5>
          <ul className="custom-list">
            <li><h6 className="educationh6">👩🏻‍💻 Implemented data mesh architecture in Azure cloud to enable faster data-driven decisions using Scala in Databricks and Data Factory to create Data Products which resulted in saving company's money.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Developed features to add resilience, auto-recovery and alerting mechanisms in data mesh via ServiceNow APIs, Logic Apps and Data Factory.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Developed PySpark reconciliation framework to compare client contracts and medicare data, saved millions.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Led database architecture and design efforts, optimizing data systems for improved performance and security using technologies such as Oracle, SQL Server, Netezza, and DB2. </h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Oversaw service design, efficient configuration, ensured strict data quality standards with Tableau & Power BI.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Contributed to data schema design and developed analytics apps using scripts in SQL, Python, and Scala. </h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Investigated alternative approaches for design, and coded efficient solutions for complex problems, leveraging programming languages such as Java, Scala, and Python.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Maintained compliance with departmental and organizational standards for design, construction, testing, and deployment activities, following best practices and coding standards.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Demonstrated strong collaborative and communication skills within cross-functional project teams, enhancing creativity and problem-solving capabilities with collaboration and communication tools.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Partnered with other competency leads and developers to support project planning, technical design, development, and solution deployment, using Agile and DevOps methodologies.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Continuously identified opportunities for process improvement, system capabilities enhancement, and delivery methodology optimization, leveraging process modeling and workflow tools.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Provided leadership, mentorship for development resources, offering project-related guidance and technical training.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Acted as a technical subject matter expert, supporting development, QA, and production support teams throughout the software development lifecycle (SDLC) and operational activities, utilizing issue tracking and version control systems.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Identified opportunities for leveraging data storage and retrieval system capabilities using Hadoop HDFS and Spark.</h6></li>
          </ul>
        </div>

      </div>

      <div className="education" id="experience-2">
        <div className="education-logo">
          <a href="https://www.optum.com/" target="_blank" rel="noreferrer"><img src={optumlogo} alt="optum Logo"></img></a>
          
        </div>
        <div className="education-text">
        <h3 className="leftalign">Optum Global Solutions, United Health Group</h3>
            <h4 className="leftalign">Software Engineer</h4>
          <h5 className="leftalign">July 2019 - Feb 2022</h5>
          <ul className="custom-list">

            <li><h6 className="educationh6">👩🏻‍💻 Standardized ETL process to create Data Products on Netezza using Spark and Airflow, showcased in OptumRx Global Town Hall of July 2020, reduced data footprint by 99% OptumRx Global Town Hall 2020.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Migrated and maintained 300TB data from Netezza and 35k+ tables from DB2 iSeries data to HDFS.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Conducted in-depth analysis of current business practices and processes, identifying opportunities for leveraging data storage and retrieval system capabilities using Hadoop HDFS and Spark.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Developed, tested, deployed complex pipelines to integrate multiple data assets using Oozie, Airflow, Azure.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Developed monitoring, reporting and reconciliation solutions using Elastic Stack for on-prem data.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Managed Platform-as-a-Service Cloud solutions with a specific focus on data stores & associated Azure ecosystems.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Designed and developed framework for Azure Resource monitoring using Azure Log Analytics and Splunk.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Developed, tested, deployed complex pipelines to integrate multiple data assets using Oozie, Airflow, Azure.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Researched on Intelligent Data Matching using Deterministic & ML based techniques for healthcare data in Python.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 6-week research project to compare imperative and reactive APIs.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Maintained compliance with departmental and organizational standards for design, construction, testing, and deployment activities, following best practices and coding standards.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Continuously identified opportunities for process improvement, system capabilities enhancement, and delivery methodology optimization, leveraging process modeling and workflow tools.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Partnered with other competency leads and developers to support project planning, technical design, development, and solution deployment, using Agile and DevOps methodologies.</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Demonstrated strong collaborative and communication skills within cross-functional project teams, enhancing creativity and problem-solving capabilities with collaboration and communication tools.</h6></li>


          </ul>
        </div>

      </div>


      
      <div className="education" id="experience-3">
        <div className="education-logo">
          <a href="https://www.linkedin.com/company/endeavr-institute/" target="_blank" rel="noreferrer"><img src={endeavrlogo} alt="ENDEAVR Logo"></img></a>
          
        </div>
        <div className="education-text">
        <h3 className="leftalign">ENDEAVR Institute</h3>
          <h4 className="leftalign">Machine Learning Engineer</h4>
          <h5 className="leftalign">Sep 2023 - Dec 2023</h5>
          <ul className="custom-list">
            <li><h6 className="educationh6">👩🏻‍💻 Employed Carla, neural networks & AI tools to create end-to-end autonomous driving solutions for underserved communities. </h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Applied computer vision, sensor data processing & AI algorithms to enhance community mobility and quality of life with Dr. Wei Li.</h6></li>
          </ul>
        </div>
      </div>




      <div className="education" id="experience-4">
        <div className="education-logo">

          <a href="https://www.tamu.edu/" target="_blank" rel="noreferrer"><img src={tamulogo} alt="TAMU Logo"></img></a>
          
        </div>
        <div className="education-text">
        <h3 className="leftalign">Harold Vance Department of Petroleum Engineering at Texas A&M University</h3>
          <h4 className="leftalign">Research Technician</h4>
          <h5 className="leftalign">Jun 2023 - Dec 2023, Jun 2024 - Present</h5>
          <ul className="custom-list">
            <li><h6 className="educationh6">👩🏻‍💻 Reviewed research papers related to applications of Machine Learning, Artificial Intelligence, Deep Learning in Energy, Decarbonization </h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Created information rich education material for students, industry professionals, managers and decision makers</h6></li>
            <li><h6 className="educationh6">👩🏻‍💻 Implemented research models and identified ways to optimize performance</h6></li>

          </ul>
        </div>
        </div>


    </>
  );
};

export default Experience;

